export default {
  replacementOrderConditionLabel: {
    id: 'express_replacement_details_replacement_order_condition_label',
    defaultMessage: 'Condition:',
  },
  replacementOrderSeller: {
    id: 'express_replacement_details_replacement_order_seller',
    defaultMessage: 'Provided by {link, html}',
  },
  gradeEco: {
    id: 'express_replacement_details_grade_eco',
    defaultMessage: 'Fair',
  },
  gradeVeryGood: {
    id: 'express_replacement_details_grade_very_good',
    defaultMessage: 'Good',
  },
  gradeFlawless: {
    id: 'express_replacement_details_grade_flawless',
    defaultMessage: 'Excellent',
  },
  gradePremium: {
    id: 'express_replacement_details_grade_premium',
    defaultMessage: 'Premium',
  },
}
